export const appBorderColor = '#dadada';
export const appBoxShadowColor = 'rgba(151, 151, 151, 0.17)';
export const appBoxShadowColorSecondary = 'rgba(153, 153, 153, 0.15)';
export const appBackgroundColor = '#FFFFFF';

export const appButtonBackground = '#FFF';
export const appButtonFontColor = '#336DEC';
export const appButtonShadowColor = 'rgba(0, 0, 0, 0.06)';
export const appButtonHoverColor = '#FFF';
export const appButtonHoverBGColor = '#336DEC';

export const headerBackgroundColor = '#FFF';
export const headerBorderColor = '#E9EFF4';

export const chatAgentBackgroundColor = '#FFF';
export const chatAgentFontColor = '#313f48';

export const chatCustomerBackgroundColor = '#336DEC';
export const chatCustomerFontColor = '#FFFFFF';
export const chatHistoryItemBorderColor = '#E9EFF4';
export const chatHistoryBGColor = '#F8FAFD';
export const chatHistoryPrimaryTextColor = '#182833';
export const chatHistorySecondaryTextColor = '#717070';
export const chatHistoryUnreadBorderColor = '#F8FAFD';
export const chatInputBorderColor = '#E3E6E9';
export const customerMessageDropShadow = 'rgba(105,105,105,0.16)';
export const userMessageDropShadow = 'rgba(105,105,105,0.1)';
export const chatInputDropShadow = 'rgba(0,0,0,0.06)';

export const errorColor = '#FF655D';
export const grayText = '#717070';

export const footerBackgroundColor = '#F8FAFD';
export const footerFontColor = '#687382';

export const chatMessageTimestamp = '#717070';

export const treePickerHover = 'rgba(82, 170, 255, 0.333)';

export const modalCloseIconColor = '#FFF';
export const modalBackgroundColor = 'rgba(0, 0, 0, 0.6)';
